import React from 'react';
import Styled from './ParceirosImplementadores.styled';
import Logo01 from '../../assets/logo_parceiro_01.svg';
import Logo02 from '../../assets/logo_parceiro_02.svg';
import partnersImage from '../../assets/parceirosImage.jpg';
import { IsMobileBiggerWidth } from 'core/util/WindowSize';

type ItemType = {
    titulo: string;
    descricao: string;
    imagem: any;
};

interface IItem {
    dados: ItemType;
}

const Item = ({ dados }: IItem) => {
    const isMobile = IsMobileBiggerWidth();
    return (
        <Styled.Item.Container isMobile={isMobile}>
            <Styled.Item.Imagem src={dados.imagem} />
            <Styled.Item.Content>
                <Styled.Item.Title>{dados.titulo}</Styled.Item.Title>
                <Styled.Item.Description>{dados.descricao}</Styled.Item.Description>
            </Styled.Item.Content>
        </Styled.Item.Container>
    );
};

const ParceirosImplementadores = () => {
    const isMobile = IsMobileBiggerWidth();
    return (
        <Styled.Container>
            <Styled.Content isMobile={isMobile}>
                <Styled.Img src={partnersImage} isMobile={isMobile} />
                <Styled.PartnersContainer isMobile={isMobile}>
                    <Styled.Title>{`Quem Caminha Junto com a Gente`.toLocaleUpperCase()}</Styled.Title>
                    <Styled.Description>{`
                    Para que essa implementação aconteça de forma concreta e sensível à realidade das escolas, contamos com parceiros que acreditam na mesma causa e caminham conosco. São equipes e pessoas 
                    comprometidas com uma educação que acolhe, transforma e fortalece vínculos. 
                    Conheça alguns dos nossos parceiros implementadores.
                    `}</Styled.Description>

                    <Item
                        dados={{
                            titulo: 'Instituto FEFIG',
                            descricao:
                                `
                                O Instituto FEFIG atua na curadoria e no apoio a projetos educacionais que apresentam resultados comprovados e potencial de alcançar cada vez mais estudantes. 
                                Seu foco é ampliar o impacto dessas iniciativas, garantindo que cheguem a um número maior de crianças e jovens, sempre com o objetivo de que possam, no futuro, 
                                se tornar políticas públicas sustentáveis e de larga escala.
                                `,
                            imagem: Logo02,
                        }}
                    />
                    {/* <Item
                        dados={{
                            titulo: 'Instituto Âncora Educação',
                            descricao:
                               `
                               O Instituto Âncora Educação atua em diferentes etapas da educação, do ensino infantil ao superior, passando também pela educação técnica, 
                               oferecendo soluções completas que integram tecnologia, inovação e práticas pedagógicas. Para ampliar seu impacto, o Instituto valoriza e fortalece uma ampla rede de 
                               relacionamentos com profissionais, instituições e comunidades, acreditando que é na colaboração que se constrói uma educação de qualidade para todos.
                               `,
                            imagem: Logo01,
                        }}
                    /> */}
                </Styled.PartnersContainer>
            </Styled.Content>
        </Styled.Container>
    );
};

export default ParceirosImplementadores;
